/* eslint-disable @typescript-eslint/no-explicit-any */
import { Carousel, Image } from 'antd'
import React, { ReactComponentElement, useEffect } from 'react'
import Logo from '../../components/Logo'
import { useRecoilValue } from 'recoil'
import appAtom from '../../atoms/app.atom'
import { useLocation, useNavigate } from 'react-router-dom'
import { isEqual } from '../../contexts/Utils'

type Props = {
  children: ReactComponentElement<any>
}

function AuthLayout({ children }: Props) {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const isAuthPath = isEqual(pathname, "/auth")
  const { estate, isAuth } = useRecoilValue(appAtom)
  const isNotAuth = Boolean(!isAuth && !isAuthPath)

  useEffect(() => { if (isNotAuth) navigate("/auth") }, [isNotAuth])

  const slides = [
    {
      title: 'Virtual Electricity Vending',
      image: '/assets/est-plus-vending.png',
      desc: 'Vend or purchase energy utility from <br /> the comfort of your space.',
    },
    {
      title: 'Communication Management',
      image: '/assets/est-plus-communication.png',
      desc: 'Various communication template like SMS, <br /> Bulk Messages, Email and others.',
    },
    {
      title: 'Convenient Payment',
      image: '/assets/est-plus-payment.png',
      desc: 'Pay for token, settlement of demand Notice, Bills and <br /> other items on various payment platform.',
    },
    {
      title: 'Issues Management',
      image: '/assets/est-plus-management.png',
      desc: 'Raise a ticket to your admin on any form <br /> of issues pertaining to your unit.',
    },
    {
      image: '/assets/est-plus-report.png',
      title: 'Analytical Flexible Reporting',
      desc: 'Generate reports of activities of all their financial <br /> transactions from period to period.',
    },
    {
      title: 'Visitors Management',
      image: '/assets/est-plus-visitor.png',
      desc: 'Manage your daily, weekly, monthly or even <br /> permanent visitation access to your unit.',
    },
  ]
  return (
    <div className='w-full h-screen md:p-5 md:bg-auth bg-center bg-cover bg-no-repeat'>
      <div className='w-full min-h-[200px] z-10 sticky top-0 bg-auth bg-center bg-cover bg-no-repeat text-white md:hidden p-5 flex flex-col justify-center items-center'>
        <Logo className='block' path={-1} imgClass='!w-[70px]' src='/assets/logo/logo-white.png'  />
        <p className='text-base font-normal text-white uppercase'>{estate?.concat(String(!estate?.includes("estate") && " Estate"))}</p>
      </div>
      <div className='w-full md:h-full grid md:grid-cols-2 gap-5'>
        <div className='w-full h-full hidden md:block'>
          <Logo path='/' className='block' imgClass='!w-[100px]' src='/assets/logo/logo-white.png'  />
          <Carousel className='w-full h-full mx-auto my-auto' autoplay fade dots={false}>
            {slides.map(({image, title, desc}) => (
              <div key={title} className='w-full h-[80vh] !flex !flex-col !justify-center !items-center gap-5 text-white'>
                <Image alt={title} src={image} preview={false} className='!w-[500px] !rounded-full' />
                <p className="text-3xl font-bold text-center">{title}</p>
                <p className="text-base text-center" dangerouslySetInnerHTML={{__html: desc}} />
              </div>
            ))}
          </Carousel>
        </div>
        <div className='w-full h-full overflow-y-auto bg-white rounded-3xl'>{children}</div>
      </div>
    </div>
  )
}

export default AuthLayout